export default "__VITE_ASSET__DM5IHs98__"